export const STEPS = {
  EMAIL: 'EMAIL_STEP',
  CONTACT: 'CONTACT_STEP',
  MOBILE: 'MOBILE_STEP',
  REVIEW: 'REVIEW_STEP',
  BIRTHDATE: 'BIRTHDATE_STEP',
  COUNTRYCODE: 'COUNTRYCODE_STEP',
  PASSWORD: 'PASSWORD_STEP',
  CODE:"BONUS_STEP",
  PRIVACYCONSENT: 'PRIVACYCONSENT_STEP',
  CREATEACCOUNT: 'CREATEACCOUNT_STEP',
  ERROR: 'ERROR_STEP',
  SUCCESS: 'SUCCESS_STEP',
  // ERRORSTEP: 'ERROR_STEP'

};

export const FIELDS = {
  EMAIL: 'email',
  CONTACT: 'contact',
  
  MOBILE: 'mobile',

  BIRTHDATE: 'birthdate',
  COUNTRYCODE: 'contrycode',
  PASSWORD : 'password',
  PRIVACYCONSENT: 'privacyconsent',
  CODE: 'code',
  CREATEACCOUNT: 'createaccount',
};

export const defaultFields = {
  contact: {
    email: '',
    // lastName: '',
    currency: '',
    address: '',
    postcode: '',
    code:'',


  },
  firstName: '', 
  // email: '',
  mobile: '',
  code: '',
  birthdate: '',
  contrycode:'',
  password:'',
  privacyconsent:'',
  createaccount:'',
};
